import { supabase } from '@/integrations/supabase/client';
import { handleServiceError } from '@/services/utils/errorHandling';
import { cleanupAuthState } from '@/utils/authCleanup';

/**
 * Account deletion service
 */
export const accountDeletionService = {
  /**
   * Delete user account permanently
   * This will sign out the user and delete their account from auth.users
   * All user data will become orphaned and cleaned up by cron job
   */
  deleteAccount: async (): Promise<{ success: boolean; error?: string }> => {
    try {
      // Call edge function to delete the user from auth.users
      // This must be done while still authenticated
      const { error: deleteError } = await supabase.functions.invoke('delete-user-account');
      
      if (deleteError) {
        throw deleteError;
      }

      // Edge function deactivated account, now sign out user locally
      cleanupAuthState();
      await supabase.auth.signOut();
      
      return { success: true };
    } catch (error) {
      handleServiceError(error, "Failed to delete account");
      return { success: false, error: "Failed to delete account" };
    }
  }
};